import PaymentPlanError from './PaymentPlanError';
class InvalidInvestorId extends PaymentPlanError {
    constructor(options) {
        super('Investor id is invalid', options);
    }
}
export default InvalidInvestorId;
